<!--
单页面示例：字段较多、两列布局；
-->
<template>

  <iframe  width="100%" style="border: 0px;" frameborder="0"  height="100%" :src="src">

  </iframe>
</template>
<script>
  import ScrollRightFrame from '../../../components/scroll-right-frame'
  import {STORE_APP_MUTATION_TYPES} from '../../../libs/constants'

  import util from '../../../libs/util'
  export default {
    name: 'dashboard',
    components: {ScrollRightFrame},
    data() {
      return {
        util:util,
        id:'',
        src:'',
        historySrc :"",
        homeUrl:''
      }
    },
    created(){
      this.src =util.baseUrl+"/project/index/index.jsp";
      this.homeUrl = util.baseUrl+"/project/index/index.jsp";
    },
    mounted(){   
    const _than =this;
    this.id =this.$route.query.id;
    window.goback =function(){
       util.routerBack(_than,"/");
    }
    window.dashboardVm = function(){
      return _than;
    };
    window.tip =function(msg){
        _than.$notify.success({title: '成功', message: msg});
    }
    window.openTab = function(title,routerName,query){
        _than.openTab(title,routerName,query);
    }    
    },
    destroyed:function(){
        window.dashboardVm = null;
    },
    methods: {
       openTab:function(title,routerName,query){
          let isOpened = false;
          let toRouter = {name: routerName}
          let currentTab = {id: routerName, routers: [toRouter,{query:query}]}
          let topTabList = this.$store.state.app.topTabList
          for (let i = 0; i < topTabList.length; i++) {
            console.info(topTabList[i].id);
            if (topTabList[i].id === routerName) {
              isOpened = true
              toRouter = util.getDestRouter(topTabList[i])
              currentTab = topTabList[i]
              break
            }
          }
          if (!isOpened) {
            // 新增一个顶部标签
            this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, {id: routerName,name:title,query:query})
          }
          // 更新currentPage
          this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, currentTab)
          // 切换路由
          const router = {
            'name': routerName,
            query: query
          }
        util.changeRouter(this, router)
           //this.$router.push(currentTab)
       }
    }
  }
</script>
<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// src/custom/components/jpcp/dashboard.vue